import React, { useState, useEffect } from "react";

import TextField from "../../../Components/Commons/Forms/TextField";
import BtnSave from "../../../Components/Commons/Buttons/BtnSave";
import BtnAdd from "../../../Components/Commons/Buttons/BtnAdd";
import TextArea from "../../Commons/Forms/TextArea";
// import SketchPad from "../../../Components/Commons/Forms/SketchPad";
import CreateSelectField from "../../../Components/Commons/Forms/CreateSelectField";
import SelectField from "../../../Components/Commons/Forms/SelectField";
import ConfirmModal from "../../../Components/Modals/ConfirmModal";

// import { Image } from "antd";
// import { createFormAttachment } from "../../Helpers/API/CheckUpApi/FormApi";
import { Icd10Api } from "../../Helpers/API/PatientApi/PatientApi";
import { getVitalSigns } from "../../Helpers/API/VitalSignsApi/VitalSignsApi";
// import IcdComponent from "./IcdComponent";
import { useParams } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { Checkbox, DatePicker, Select } from "antd";
import {
  createCheckUp,
  updateCheckUp,
  getAutoSuggestTherapeutics,
} from "../../Helpers/API/CheckUpApi/CheckUpApi";
import { toast } from "react-toastify";
import { validateCheckUp } from "../../Helpers/Utilities/Validations/CheckUp";
import dayjs from "dayjs";
import { getRole, getUser } from "../../Helpers/Utilities/Common";
import { DeleteOutlined } from "@ant-design/icons";
// import { refreshPage } from "../../Helpers/Utilities/Common";

const { Option } = Select;

function CheckUp({
  showAdmit,
  showOutPatient,
  addCheckUpData,
  setAddCheckUpData,
  addCheckupDiagnosis,
  setAddCheckupDiagnosis,
  fetchAssessmentHistory,
  assessment,
  doctorOptions,
  setSelectedCheckUpTab,
}) {
  const { id } = useParams();
  const role = getRole();
  const userId = getUser();
  const [showLoader, setShowLoader] = useState(false);
  // const [showSketchPad, setShowSketchPad] = useState(false);
  const [prompt, setPrompt] = useState(false);
  // const [sketchImage, setSketchImage] = useState(null);
  const [suggestDiagnosis, setSuggestDiagnosis] = useState([]);
  const [suggestComplaint, setSuggestComplaint] = useState([]);
  const [icd10Diagnosis, setIcd10Diagnosis] = useState([]);
  const [icd10DiagnosisList, setIcd10DiagnosisList] = useState({});
  const [checkup, setCheckup] = useState("");
  const [vitalChiefComplaint, setVitalChiefComplaint] = useState("");
  const [isError, setIsError] = useState({
    diagnosis: "",
  });

  //Function for handling the value of the input fields
  const handleAddChange = (e, search) => {
    if (search === "complaint") {
      setAddCheckUpData((prevState) => ({
        ...prevState,
        [search]: e?.value,
      }));
    } else if (
      search === "is_surgical_outpatient" ||
      search === "is_sunday_patient"
    ) {
      // Handle checkbox value (1 for checked, 0 for unchecked)
      setAddCheckUpData((prevState) => ({
        ...prevState,
        [search]: e.target.checked ? "1" : "0",
      }));
    } else {
      const { name, value } = e.target;
      if (name === "procedure") {
        setAddCheckUpData((prevState) => ({
          ...prevState,
          [name]: value?.toUpperCase(),
        }));
      } else {
        setAddCheckUpData((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    }
  };

  const handleDiagnosisChange = (index, field, value) => {
    const updated = [...addCheckupDiagnosis];
    if (field === "sub_diagnosis") {
      const result = value.target.value;
      updated[index]["sub_diagnosis"] = result;
      updated[index]["diagnosis_name"] = result;
      updated[index]["diagnosis_search"] = result;
      setAddCheckupDiagnosis(updated);
      setIcd10DiagnosisList({});
    } else {
      updated[index][field] = value;
      setAddCheckupDiagnosis(updated);
    }
  };

  const handleaddCheckupDiagnosis = () => {
    setAddCheckupDiagnosis((prev) => [...prev, { diagnosis_name: "" }]);
  };

  const handleRemoveDiagnosis = (index) => {
    setAddCheckupDiagnosis((prev) => prev.filter((_, i) => i !== index));
  };

  // Function for handling date for all diagnostics
  function handleDateChange(dateTime) {
    var formattedDateTime = dateTime ? dateTime.format("YYYY-MM-DD") : null;
    setAddCheckUpData((prev) => ({
      ...prev,
      last_checkup_date: formattedDateTime,
    }));
  }

  // Function for handling selected doctor
  function handleDoctorChange(value) {
    setAddCheckUpData((prev) => ({
      ...prev,
      doctor_id: value,
    }));
  }

  // const handleSetText = (data) => {
  //   setAddCheckUpData((prevState) => ({
  //     ...prevState,
  //     diagnosis: data,
  //   }));
  // };

  // const handleSetSketchImage = (image) => {
  //   setSketchImage(image)
  // };

  function handleCheckupType(type) {
    if (type === "for_admission") {
      addCheckUpIn();
    } else if (type === "outpatient") {
      addCheckUpOut();
    }
  }

  function handleCheckupButtons(name) {
    setPrompt(true);
    if (name === "outpatient") {
      setCheckup(name);
    } else if (name === "for_admission") {
      setCheckup(name);
    }
  }
  // async function handleUploadSketchImage(assessment_id) {
  //   // if (validateFileSize(sketchImage)) {
  //     const response = await createFormAttachment(id, [{file: sketchImage}], "diagnosis", "", "", assessment_id)
  //     if (response.error) {
  //       response.error?.data?.messages?.error_messages.map((data) => {
  //         return toast.error(data)
  //       })
  //     } else {
  //       toast.success("Successfully uploaded file!")
  //       // refreshPage();
  //     }
  //   // } else {
  //   //   toast.error("Invalid. File size exceeded 5MB.");
  //   // }
  // }

  async function fetchAutoSuggestTherapeutics() {
    setShowLoader(true);
    const response = await getAutoSuggestTherapeutics({
      table: "assessment_diagnosis",
      field: "diagnosis_name",
    });
    if (response.data) {
      setSuggestDiagnosis(
        response?.data?.data
          ?.filter((data) => data !== null && data !== undefined && data !== "")
          ?.map((data) => ({ label: data, value: data }))
      );
    } else {
      setSuggestDiagnosis([]);
    }
    setShowLoader(false);
  }

  // Fetch latest vital sign's chief complaint (entered by nurse) to auto-fill check-up tab
  async function fetchVitalChiefComplaint() {
    if (!id) return;
    const res = await getVitalSigns(id);
    const payload = res?.data?.data;
    const list =
      (Array.isArray(payload) ? payload : payload?.data) ||
      payload?.records ||
      [];
    if (Array.isArray(list) && list.length > 0) {
      const latestVital = list[0];
      const cc = (
        latestVital?.chief_complaint ||
        latestVital?.complaint ||
        latestVital?.chiefComplaint ||
        ""
      ).toString();
      if (cc.trim()) setVitalChiefComplaint(cc.trim());
    }
  }

  useEffect(() => {
    fetchVitalChiefComplaint();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    const onFocus = () => {
      if (!addCheckUpData?.complaint) fetchVitalChiefComplaint();
    };
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, addCheckUpData?.complaint]);

  useEffect(() => {
    if (addCheckUpData?.complaint) return;
    const intervalId = setInterval(() => {
      fetchVitalChiefComplaint();
    }, 5000);
    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, addCheckUpData?.complaint]);

  async function fetchAutoSuggestComplaint() {
    setShowLoader(true);
    const response = await getAutoSuggestTherapeutics({
      table: "assessment",
      field: "complaint",
    });
    if (response.data) {
      setSuggestComplaint(
        response?.data?.data
          ?.filter((data) => data !== null && data !== undefined && data !== "")
          ?.map((data) => ({ label: data, value: data }))
      );
    } else {
      setSuggestComplaint([]);
    }
    setShowLoader(false);
  }

  async function Icd10(index, diagnosisName) {
    const response = await Icd10Api(diagnosisName);
    if (response?.data) {
      const _data =
        response.data[3]?.map((icd) => ({
          label: icd[0] + " - " + icd[1],
          value: icd[0] + " - " + icd[1],
        })) || [];

      setIcd10DiagnosisList((prev) => ({
        ...prev,
        [index]: [{ label: "Select ICD Diagnosis", value: "" }, ..._data],
      }));
    } else {
      setIcd10DiagnosisList((prev) => ({
        ...prev,
        [index]: [],
      }));
    }
  }
  // Function for creating admission API
  async function addCheckUpIn() {
    setShowLoader(true);
    if (role !== "nurse") {
      addCheckUpData.doctor_id = userId;
    }
    if (validateCheckUp(addCheckUpData, setIsError)) {
      const response = await createCheckUp(addCheckUpData, id, "for_admission");
      if (response.data) {
        toast.success(response.data.message);
        showAdmit(true);
        fetchAssessmentHistory();
        setSelectedCheckUpTab("assessment");
        // handleUploadSketchImage(response.data.assessment_id);
      }
    }
    setPrompt(false);
    setShowLoader(false);
  }

  // const handleKeyPress = (event) => {
  //   // Check if the pressed key is Enter (key code 13)
  //   if (event.key === 'Enter') {
  //     // Trigger the button click event
  //     Icd10();
  //   }
  // };

  // Function for creating Outpatient API
  async function addCheckUpOut() {
    setShowLoader(true);
    if (role !== "nurse") {
      addCheckUpData.doctor_id = userId;
    }
    addCheckUpData.diagnosis = addCheckupDiagnosis;
    const response = await createCheckUp(addCheckUpData, id, "outpatient");
    if (response.data) {
      toast.success(response.data.message);
      showOutPatient(true);
      fetchAssessmentHistory();
      setSelectedCheckUpTab("assessment");
      // handleUploadSketchImage(response.data.assessment_id);
    } else if (response.error) {
      response.error.data.messages.error_messages.forEach((errMsg) => {
        toast.error(errMsg);
      });
    }
    setPrompt(false);
    setShowLoader(false);
  }
  // Function edit checkup API
  async function editCheckUp() {
    setShowLoader(true);
    addCheckUpData.diagnosis = addCheckupDiagnosis;
    const response = await updateCheckUp(addCheckUpData, id);
    if (response.data) {
      toast.success(response.data.message);

      if (addCheckUpData.type === "outpatient") {
        showOutPatient(true);
      } else if (addCheckUpData.type === "for_admission") {
        showAdmit(true);
      }
      setSelectedCheckUpTab("assessment");
    } else if (response.error) {
    }
    setShowLoader(false);
  }

  useEffect(() => {
    fetchAutoSuggestTherapeutics();
    fetchAutoSuggestComplaint();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Autofill complaint if empty (don't override doctor's existing input)
  useEffect(() => {
    if (vitalChiefComplaint && !addCheckUpData?.complaint) {
      setAddCheckUpData((prev) => ({
        ...prev,
        complaint: vitalChiefComplaint,
      }));
    }
  }, [vitalChiefComplaint, addCheckUpData?.complaint, setAddCheckUpData]);

  // useEffect(() => {
  //   Icd10();
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  return (
    <div className="tabs-box p-3">
      <div className="col pt-1">
        <div className="">
          <div className="row mt-2">
            <div className="col-sm-12">
              <label className="col-6 font-bold font-large ">
                General Consultation
              </label>
              <hr />
              <div className="row pl-4 pt-1 mb-3">
                <div className="row">
                  <div className="col">
                    <Checkbox
                      id="is_surgical_outpatient"
                      name="is_surgical_outpatient"
                      value={addCheckUpData.is_surgical_outpatient}
                      checked={addCheckUpData.is_surgical_outpatient === "1"}
                      onChange={(e) =>
                        handleAddChange(e, "is_surgical_outpatient")
                      }
                    >
                      Surgical Outpatient{" "}
                      <em>(Check if patient is a Surgical Outpatient)</em>
                    </Checkbox>
                  </div>
                </div>
                {addCheckUpData.is_surgical_outpatient === "1" && (
                  <>
                    <div className="row">
                      <div className="col mt-2 ms-4">
                        <TextField
                          id="procedure"
                          type={``}
                          formLabel={`Procedure`}
                          size={`sm`}
                          name="procedure"
                          value={addCheckUpData.procedure}
                          onChange={handleAddChange}
                        />
                      </div>
                      <div className="col-2 mt-2">
                        <TextField
                          id="pf"
                          type={``}
                          formLabel={`PF`}
                          size={`sm`}
                          name="pf"
                          value={addCheckUpData.pf}
                          onChange={handleAddChange}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col ms-4">
                        <TextArea
                          id="notes"
                          type={``}
                          formLabel={`Surgical Notes`}
                          size={`sm`}
                          name="notes"
                          value={addCheckUpData.notes}
                          onChange={handleAddChange}
                        />
                      </div>
                    </div>
                  </>
                )}
                {/* <div className="row mt-3">
                  <div className="col">
                    <Checkbox
                      id="is_sunday_patient"
                      name="is_sunday_patient"
                      value={addCheckUpData.is_sunday_patient}
                      checked={addCheckUpData.is_sunday_patient === "1"} 
                      onChange={(e) => handleAddChange(e, "is_sunday_patient")}
                    >
                      Sunday Patient <em>(Check if patient is a Sunday Patient)</em>
                    </Checkbox>
                  </div>
                </div> */}
                {addCheckUpData.is_sunday_patient === "1" && (
                  <div className="row">
                    <div className="col-4 mt-2 ms-4">
                      Last Check Up Date of Patient:
                      <DatePicker
                        id="last_checkup_date"
                        name="last_checkup_date"
                        className="w-100"
                        format="YYYY-MM-DD"
                        placeholder="Select Date"
                        value={
                          addCheckUpData?.last_checkup_date
                            ? dayjs(addCheckUpData.last_checkup_date)
                            : null
                        }
                        onChange={(date) => handleDateChange(date)}
                        allowClear
                        disabledDate={(current) =>
                          current && current.isAfter(dayjs(), "day")
                        }
                      />
                    </div>
                  </div>
                )}
                {/* {role === "nurse" && (
                  <>
                    <div className="row mt-3">
                      <div className="col-4">
                        <p className="m-0">
                          Assigned Doctor<span className="red"> *</span>
                        </p>
                        <Select
                          style={{ width: "100%" }}
                          placeholder="Select Doctor"
                          value={addCheckUpData.doctor_id}
                          onChange={(value) => handleDoctorChange(value)}
                          allowClear
                          options={doctorOptions}
                          optionFilterProp="label"
                          showSearch
                        />
                      </div>
                    </div>
                  </>
                )} */}
                <div className="row mt-3">
                  <CreateSelectField
                    required={true}
                    id={"complaint"}
                    errorMessage="Required"
                    className="dropsearch-filter"
                    name="complaint"
                    size={`sm`}
                    formLabel={"Chief Complaint"}
                    options={suggestComplaint}
                    value={{
                      label: addCheckUpData?.complaint || vitalChiefComplaint,
                      value: addCheckUpData?.complaint || vitalChiefComplaint,
                    }}
                    isMessage={true}
                    onChange={(e) => handleAddChange(e, "complaint")}
                    onInputChange={(inputValue) => inputValue.toUpperCase()}
                  />
                </div>
                <div className="row">
                  <TextField
                    required
                    id="subjective"
                    formLabel={`Subjective`}
                    size={`sm`}
                    name="subjective"
                    value={addCheckUpData.subjective}
                    onChange={handleAddChange}
                  />
                </div>
                <div className="row">
                  <TextField
                    required
                    id="objective"
                    formLabel={`Objective`}
                    size={`sm`}
                    name="objective"
                    value={addCheckUpData.objective}
                    onChange={handleAddChange}
                  />
                </div>
                {/* <div className="row">
                  <TextArea
                    id="checkup_note"
                    type={``}
                    formLabel={`Check Up Notes`}
                    size={`sm`}
                    name="checkup_note"
                    value={addCheckUpData.checkup_note}
                    onChange={handleAddChange}
                  />
                </div>
                <div className="row">
                  <TextArea
                    id="illness_history"
                    type={``}
                    formLabel={`Hx of Present Illness`}
                    size={`sm`}
                    name="illness_history"
                    value={addCheckUpData.illness_history}
                    onChange={handleAddChange}
                  />
                </div>
                <div className="row">
                  <div className="col check-up-eachBar">
                    <TextField
                      id="heent"
                      type={``}
                      formLabel={`HEENT`}
                      size={`sm`}
                      name="heent"
                      value={addCheckUpData.heent}
                      onChange={handleAddChange}
                    />
                  </div>
                  <div className="col check-up-eachBar">
                    <TextField
                      id="cl"
                      type={``}
                      formLabel={`C/L`}
                      size={`sm`}
                      name="cl"
                      value={addCheckUpData.cl}
                      onChange={handleAddChange}
                    />
                  </div>
                  <div className="col check-up-eachBar">
                    <TextField
                      id="cvs"
                      type={``}
                      formLabel={`CVS`}
                      size={`sm`}
                      name="cvs"
                      value={addCheckUpData.cvs}
                      onChange={handleAddChange}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col check-up-eachBar">
                    <TextField
                      id="abdomen"
                      type={``}
                      formLabel={`Abdomen`}
                      size={`sm`}
                      name="abdomen"
                      value={addCheckUpData.abdomen}
                      onChange={handleAddChange}
                    />
                  </div>
                  <div className="col check-up-eachBar">
                    <TextField
                      id="skin"
                      type={``}
                      formLabel={`Skin`}
                      size={`sm`}
                      name="skin"
                      value={addCheckUpData.skin}
                      onChange={handleAddChange}
                    />
                  </div>
                  <div className="col check-up-eachBar">
                    <TextField
                      id="extremities"
                      type={``}
                      formLabel={`Extremities`}
                      size={`sm`}
                      name="extremities"
                      value={addCheckUpData.extremities}
                      onChange={handleAddChange}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col check-up-eachBar">
                    <TextField
                      id="general_survey"
                      type={``}
                      formLabel={`General Survey`}
                      size={`sm`}
                      name="general_survey"
                      value={addCheckUpData.general_survey}
                      onChange={handleAddChange}
                    />
                  </div>
                  <div className="col check-up-eachBar">
                    <TextField
                      id="neurologic"
                      type={``}
                      formLabel={`Neurologic System`}
                      size={`sm`}
                      name="neurologic"
                      value={addCheckUpData.neurologic}
                      onChange={handleAddChange}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col check-up-eachBar">
                    <TextField
                      id="pertinent_diagnostics"
                      type={``}
                      formLabel={`Pertinent Diagnostics`}
                      size={`sm`}
                      name="pertinent_diagnostics"
                      value={addCheckUpData.pertinent_diagnostics}
                      onChange={handleAddChange}
                    />
                  </div>
                </div> */}
                <div>
                  <span>
                    Assessment
                    <label className="red"> *</label>
                  </span>
                </div>
                {addCheckupDiagnosis?.map((item, index) => (
                  <div key={index}>
                    <div className="row">
                      <div className="col-5 diagnosis-bar">
                        <TextField
                         id={`diagnosis_search_${index}`}
                          size={`sm`}
                          name="diagnosis_search"
                          placeholder="Search"
                          value={item.diagnosis_search || ""}
                          onChange={(e) =>
                            handleDiagnosisChange(
                              index,
                              "diagnosis_search",
                              e.target.value
                            )
                          }
                          onInputChange={(inputValue) =>
                            inputValue.toUpperCase()
                          }
                        />
                      </div>

                      <div className="col-3">
                        <BtnSave
                          id="diagnosis-two-buttons"
                          label="Search ICD Codes/Name"
                          size="sm"
                          onClick={() => Icd10(index, item.diagnosis_search)}
                          isClicked={showLoader}
                          className="custom-btn"
                        />
                      </div>

                      <div className="col-1 pt-1">
                        <DeleteOutlined
                          className="trash-icon"
                          style={{
                            fontSize: "24px",
                            color: "red",
                            cursor: "pointer",
                          }}
                          onClick={() => handleRemoveDiagnosis(index)}
                        />
                      </div>
                    </div>

                    {icd10DiagnosisList[index]?.length > 0 && (
                      <div className="row">
                        <div className="col-6">
                          <SelectField
                            id={`sub_diagnosis_${index}`}
                            errorMessage="Required"
                            className="dropsearch-filter"
                            name="sub_diagnosis"
                            size="md"
                            options={icd10DiagnosisList[index]}
                            value={item.sub_diagnosis || ""}
                            isMessage={true}
                            onChange={(e) =>
                              handleDiagnosisChange(index, "sub_diagnosis", e)
                            }
                          />
                        </div>
                      </div>
                    )}
                  </div>
                ))}
                <div className="row">
                  <div className="col-2">
                    <BtnSave
                      id={"diagnosis-two-buttons"}
                      label={"+ Add Diagnosis"}
                      size={"sm"}
                      className="custom-btn"
                      onClick={handleaddCheckupDiagnosis}
                    />
                  </div>
                </div>
                <div className="row">
                    <div>
                      <TextArea
                        required
                        id="plan"
                        name="plan"
                        formLabel={`Plan`}
                        size={`lg`}
                        value={addCheckUpData.plan}
                        onChange={handleAddChange}
                      />
                    </div>
                  </div>
              </div>
            </div>
          </div>
          <Row className="justify-content-end mt-5 mb-3">
            {addCheckUpData.id ? (
              <>
                <Col xs={2} className="col-container">
                  <BtnSave
                    label={"Save Changes"}
                    size={"sm"}
                    onClick={editCheckUp}
                    isClicked={showLoader}
                    disabled={
                      !addCheckUpData ||
                      !addCheckUpData.doctor_id ||
                      !addCheckUpData.complaint ||
                      !addCheckUpData.subjective ||
                      !addCheckUpData.objective ||
                      !addCheckUpData.plan ||
                      !addCheckupDiagnosis ||
                      addCheckupDiagnosis.length === 0 ||
                      addCheckupDiagnosis.some(
                        (item) =>
                          !item?.diagnosis_name ||
                          item?.diagnosis_name.trim() === ""
                      )
                    }
                  />
                </Col>
              </>
            ) : (
              <>
                <Col xs={2} className="col-container">
                  <BtnAdd
                    label={"Proceed"}
                    size={"sm"}
                    onClick={() => handleCheckupButtons("outpatient")}
                    isClicked={showLoader}
                    disabled={
                      !addCheckUpData ||
                      (role === "nurse" && !addCheckUpData.doctor_id) ||
                      !addCheckUpData.complaint ||
                      !addCheckUpData.subjective ||
                      !addCheckUpData.objective ||
                      !addCheckUpData.plan ||
                      !addCheckupDiagnosis ||
                      addCheckupDiagnosis.length === 0 ||
                      addCheckupDiagnosis.some(
                        (item) =>
                          !item?.diagnosis_name ||
                          item?.diagnosis_name.trim() === ""
                      )
                    }
                  />
                </Col>
              </>
            )}
          </Row>
        </div>
      </div>
      <ConfirmModal
        show={prompt}
        onHide={() => setPrompt(false)}
        onConfirm={() => handleCheckupType(checkup)}
        message={
          <>
            <p>
              Are you sure this is the right diagnosis for this patient (
              {checkup ? checkup : ""})?
            </p>
            {addCheckupDiagnosis?.length > 0 && (
              <div style={{ textAlign: "left" }}>
                <ul className="mx-3">
                  {addCheckupDiagnosis.map((d, index) => (
                    <li key={index}>{d.diagnosis_name}</li>
                  ))}
                </ul>
              </div>
            )}
          </>
        }
      />
    </div>
  );
}

export default CheckUp;
